<template>
  <div class="agreement">
    <div class="content" v-if="type=='agr'">{{ruleCotent&&ruleCotent.content}}</div>
    <div class="content" v-else-if="type=='pri'">{{ruleCotent&&ruleCotent.privacy}}</div>
  </div>
</template>
<script>
import fun from "@/common/js/common.js";
export default {
  name: "agreement",
  props:['type'],
  data(){
    return{
        adid:"",
        ruleCotent:""
    }
  },
  mounted() {
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
      this.getRule();
  },
  methods: {
    getRule() {
      this.$http
        .get(fun.apiUrl + "api/member/agreement?adid="+ this.adid , { adid: this.adid })
        .then(function (res) {
          if (res.body.code == 200) {
            this.ruleCotent = res.body.data;
          } else {
            this.$toast.text(res.body.msg);
          }
        });
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.agreement{
    width: 100%;
    height: 100%;
    padding: .2rem;
    box-sizing: border-box;
    overflow-y: scroll;
}
.content{
    width: 100%;
    height: 100%;
    color: #333;
    font-size: 14px;
    line-height: .36rem;
    white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/agreement.vue